"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromDb = exports.toDb = void 0;
const utils_1 = require("../dbNodes/utils");
const assetVerification_1 = require("./assetVerification");
const assignedLoanTape_1 = require("./assignedLoanTape");
const assignedRepaymentTape_1 = require("./assignedRepaymentTape");
const assignmentUserInput_1 = require("./assignmentUserInput");
const borrowingBaseReport_1 = require("./borrowingBaseReport");
const busReconcileApprovalUserInput_1 = require("./busReconcileApprovalUserInput");
const busUploadToDatalake_1 = require("./busUploadToDatalake");
const cashBalancesFeedContext_1 = require("./cashBalancesFeedContext");
const cashBalanceUserInput_1 = require("./cashBalanceUserInput");
const cashResponseTape_1 = require("./cashResponseTape");
const covenantLoanTape_1 = require("./covenantLoanTape");
const datalakeWaitUserInput_1 = require("./datalakeWaitUserInput");
const directInsertBorrowingBaseReport_1 = require("./directInsertBorrowingBaseReport");
const internalRepaymentTape_1 = require("./internalRepaymentTape");
const lenderApprovalFlow_1 = require("./lenderApprovalFlow");
const manualBankAccountReport_1 = require("./manualBankAccountReport");
const masterLoanTape_1 = require("./masterLoanTape");
const valleySlsIngest_1 = require("./valleySlsIngest");
// synthetic processes should be defined as series of steps.
// each step is responsible for attaching or detaching its own thing.
// The order is very important. the processes assume the graph in specific state.
// they will be executed in order when saving to db. and in reverse order when reading from db.
const syntheticProcessesToDb = [
    masterLoanTape_1.syntheticProcess,
    assignedLoanTape_1.syntheticProcess,
    covenantLoanTape_1.syntheticProcess,
    manualBankAccountReport_1.syntheticProcess,
    cashBalancesFeedContext_1.syntheticProcess,
    cashResponseTape_1.syntheticProcess,
    internalRepaymentTape_1.syntheticProcess,
    // Requires the assigned loan tape and internal repayment tape; BBR runs after it.
    assignedRepaymentTape_1.syntheticProcess,
    borrowingBaseReport_1.syntheticProcess,
    directInsertBorrowingBaseReport_1.syntheticProcess,
    cashBalanceUserInput_1.syntheticProcess,
    assignmentUserInput_1.syntheticProcess,
    lenderApprovalFlow_1.syntheticProcess,
    assetVerification_1.syntheticProcess,
    datalakeWaitUserInput_1.syntheticProcess,
    valleySlsIngest_1.syntheticProcess,
    // BUS datalake upload: must precede the approval gate, which then
    // interposes on its reconcile edge (so the upload runs only once accepted).
    busUploadToDatalake_1.syntheticProcess,
    // BUS approval gate — independent of the steps above it (operates only on
    // `reconciledBusTape`), so its position among them is not load-bearing.
    busReconcileApprovalUserInput_1.syntheticProcess,
];
const syntheticProcessesFromDb = [...syntheticProcessesToDb].reverse();
const toDb = (dbGraph) => {
    const context = {
        loanTapeTypeMap: (0, utils_1.generateLoanTapeTypeMap)(dbGraph.dataTapes),
        sourceGraph: dbGraph,
    };
    return syntheticProcessesToDb.reduce((acc, process) => process.toDb(acc, context), dbGraph);
};
exports.toDb = toDb;
const fromDb = (dbGraph) => {
    const context = {
        loanTapeTypeMap: (0, utils_1.generateLoanTapeTypeMap)(dbGraph.dataTapes),
        sourceGraph: dbGraph,
    };
    return syntheticProcessesFromDb.reduce((acc, process) => process.fromDb(acc, context), dbGraph);
};
exports.fromDb = fromDb;
//# sourceMappingURL=syntheticOrder.js.map